export enum ReplyType {
  CUSTOM = 'custom', // シンプルなカスタム返信のみ
}

export enum ReplyStatus {
  DRAFT = 'draft',
  SENT = 'sent',
  DELIVERED = 'delivered',
  READ = 'read',
  RESPONDED = 'responded',
}

export enum MessageStatus {
  SENT = 'sent',
  DELIVERED = 'delivered',
  READ = 'read',
  REPLIED = 'replied',
}

export enum MessagePriority {
  LOW = 'low',
  NORMAL = 'normal',
  HIGH = 'high',
}

export interface MessageThread {
  id: string;
  company: {
    id: number;
    name: string;
    logo_url?: string;
    business_type?: string;
    verified?: boolean;
  };
  latest_sender?: {
    name: string;
    title?: string;
  };
  subject: string;
  latest_message?: {
    preview: string;
    sent_at: string;
    sender_type: 'company' | 'student';
  };
  status: MessageStatus;
  priority: MessagePriority;
  message_count: number;
  unread_count: number;
  is_starred: boolean;
  is_archived: boolean;
  tags?: string[];
  last_message_at: string;
}

export interface ThreadMessage {
  id: number;
  sender_type: 'company' | 'student';
  sender: {
    name: string;
    title?: string;
    avatar_url?: string;
  };
  message_body: string;
  reply_type?: ReplyType;
  sent_at: string;
  read_at?: string;
  is_ai_assisted: boolean;
}

export interface ThreadDetail {
  id: string;
  company: {
    id: number;
    name: string;
    logo_url?: string;
    business_type: string;
    verified: boolean;
  };
  subject: string;
  status: string;
  created_at: string;
  is_starred: boolean;
  is_archived: boolean;
  tags: string[];
  notes?: string;
}

// 返信テンプレート機能は削除されました

export interface GetMessagesQuery {
  status?: MessageStatus[];
  priority?: MessagePriority[];
  company_ids?: number[];
  has_keyword?: string;
  is_starred?: boolean;
  is_archived?: boolean;
  tags?: string[];
  page?: number;
  limit?: number;
  sort?: 'received_at' | 'company_name' | 'priority';
  order?: 'asc' | 'desc';
}

export interface ReplyMessageRequest {
  message_body: string;
  additional_question?: string;
  // reply_type は削除（バックエンドで自動的に 'custom' に設定）
}

export interface GetMessagesResponse {
  success: true;
  data: {
    messages: MessageThread[]; // バックエンドは 'messages' フィールド
    pagination: {
      current_page: number;
      total_pages: number;
      total_count: number; // バックエンドは 'total_count'
      per_page: number; // バックエンドは 'per_page'
    };
    summary: {
      total_unread: number;
      total_starred: number;
      total_archived: number;
      total_messages: number; // バックエンドは 'total_messages'
      new_this_week: number;
    };
  };
}

export interface GetThreadResponse {
  success: true;
  data: {
    message: ThreadDetail; // バックエンドは 'message' フィールド
    replies: ThreadMessage[]; // バックエンドは 'replies' フィールド
    can_reply: boolean; // バックエンドは直接フィールド
  };
}

export interface ReplyMessageResponse {
  success: true;
  data: {
    reply_id: number; // バックエンドは 'reply_id'
    message_id: number;
    status: 'sent' | 'delivered' | 'read';
    sent_at: string; // バックエンドは 'sent_at'
  };
  message: string; // バックエンドは 'message' フィールドあり
}

// 返信テンプレート機能は削除されました
